import { render, staticRenderFns } from "./ModalAlerta.vue?vue&type=template&id=66986656&"
import script from "./ModalAlerta.vue?vue&type=script&lang=js&"
export * from "./ModalAlerta.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlerta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports